export default "__VITE_ASSET__BvW3glF3__"